module.exports = __webpack_public_path__ + "img/mobileladdercontrol4.4367846f.png";